import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* LIBRARIES */
import classNames from 'classnames';
/* STYLES */

import * as stylesModule from '../styles.css';
/* TYPES */

export var getCustomClasses = function getCustomClasses(custom) {
  return classNames(_defineProperty({}, stylesModule["container-hoveredColor--".concat(custom.hoveredColor)], custom.hoveredColor));
};
export var getStylesClasses = function getStylesClasses(props, config) {
  var _classNames2;

  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles;
  var color = styles.color || config && config.defaultColor;
  return classNames((_classNames2 = {}, _defineProperty(_classNames2, stylesModule["container-display--".concat(styles.display)], styles.display), _defineProperty(_classNames2, stylesModule["container-color--".concat(color)], color), _classNames2));
};
export var getInlineStyles = function getInlineStyles(props) {
  var size = props.custom.size || '100px';

  if (/^\d+$/.test(size)) {
    size = "".concat(size, "px");
  }

  return {
    width: size,
    height: size
  };
};